export class OffersContext {
    public routeTo: string[] = []
    public nextTo: string = ""
    public offerDetailSteps: string[] = []

    constructor() { }
}